import { render, staticRenderFns } from "./kick-user.vue?vue&type=template&id=332b20d0&scoped=true"
import script from "./kick-user.vue?vue&type=script&lang=js"
export * from "./kick-user.vue?vue&type=script&lang=js"
import style0 from "./kick-user.vue?vue&type=style&index=0&id=332b20d0&prod&lang=css&scoped=true"
import style1 from "./kick-user.vue?vue&type=style&index=1&id=332b20d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332b20d0",
  null
  
)

export default component.exports